import { render, staticRenderFns } from "./digitization.vue?vue&type=template&id=7ab8c038&scoped=true&"
import script from "./digitization.vue?vue&type=script&lang=js&"
export * from "./digitization.vue?vue&type=script&lang=js&"
import style0 from "./digitization.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./digitization.vue?vue&type=style&index=1&id=7ab8c038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab8c038",
  null
  
)

export default component.exports